import { Layout, RevisionSystem } from "components"
export const Revision = () => {
 return (
  <Layout>
   <RevisionSystem />
  </Layout>
 )
}
